// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__vetp5","link":"Breadcrumbs_link__v9yGv"};